import React from 'react';
import { LayerGroup, TileLayer } from 'react-leaflet';
import { createLayerComponent, LayerProps } from '@react-leaflet/core';
import L from 'leaflet';
// The package's ESM build named-imports from maplibre-gl's UMD bundle, which webpack 4 rejects.
import { maplibreGL } from '@maplibre/maplibre-gl-leaflet/leaflet-maplibre-gl';
import maplibregl from 'maplibre-gl';
// CRA transpiles node_modules to ES5, which breaks maplibre's inlined Blob worker (grey map, no tiles).
// Serving the prebuilt CSP worker as a raw file bypasses Babel.
// eslint-disable-next-line import/no-webpack-loader-syntax
import maplibreWorkerUrl from '!file-loader!maplibre-gl/dist/maplibre-gl-csp-worker.js';
import 'maplibre-gl/dist/maplibre-gl.css';

maplibregl.workerUrl = maplibreWorkerUrl;

const ESRI_CANVAS_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas';
// Esri Light Gray Canvas has no tiles past zoom 16; Leaflet upscales them beyond that.
const ESRI_LIGHT_GRAY_MAX_NATIVE_ZOOM = 16;

export const OPEN_FREE_MAP_POSITRON_STYLE = 'https://tiles.openfreemap.org/styles/positron';

export const EsriLightGrayLayer: React.FC = () => (
  <LayerGroup>
    <TileLayer
      attribution="Tiles &copy; Esri &mdash; Esri, HERE, Garmin, &copy; OpenStreetMap contributors"
      url={`${ESRI_CANVAS_URL}/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}`}
      maxNativeZoom={ESRI_LIGHT_GRAY_MAX_NATIVE_ZOOM}
    />
    <TileLayer
      url={`${ESRI_CANVAS_URL}/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}`}
      maxNativeZoom={ESRI_LIGHT_GRAY_MAX_NATIVE_ZOOM}
    />
  </LayerGroup>
);

interface MaplibreLayerProps extends LayerProps {
  styleUrl: string;
}

export const MaplibreLayer = createLayerComponent<L.MaplibreGL, MaplibreLayerProps>(({ styleUrl }, context) => ({
  instance: maplibreGL({ style: styleUrl }),
  context,
}));
